export const PHRASE_TRIGGER_GROUP = "phrase_trigger_id";
